import { AnnotationType } from 'types/types'

import { AnnotatedCharacter } from './AnnotatedCharacter'
import { AnnotatedSegment } from './AnnotatedSegment'

class AnnotatedWord {
  private xsegment: AnnotatedSegment

  private text: string

  private annotations: Array<AnnotationType | null>

  private xindex: number

  private xoffsetInSentence: number

  private characters: Array<AnnotatedCharacter>

  constructor(segment: AnnotatedSegment, index: number, offsetInSentence: number, text: string, annotations: Array<AnnotationType | null>) {
    this.xsegment = segment
    this.xindex = index
    this.xoffsetInSentence = offsetInSentence
    this.text = text
    this.annotations = [...annotations]

    this.characters = new Array<AnnotatedCharacter>()
    this.generate()
  }

  segment(): AnnotatedSegment {
    return this.xsegment
  }

  offsetInSentence(): number {
    return this.xoffsetInSentence
  }

  word(): string {
    return this.text
  }

  nChars(): number {
    return this.text.length
  }

  index(): number {
    return this.xindex
  }

  generate(): void {
    this.characters.splice(0, this.characters.length)
    ;[...this.text].forEach((character, index) => {
      const sentenceIndex = this.xoffsetInSentence + index
      const annotation = this.annotations[index]
      const annotatedCharacter = new AnnotatedCharacter(this, sentenceIndex, character, annotation)
      this.characters.push(annotatedCharacter)
    })
  }

  lastChar(): AnnotatedCharacter | null {
    for (let i = this.characters.length - 1; i >= 0; i--) {
      if (this.characters[i]) {
        return this.characters[i]
      }
    }
    return null
  }

  some(predicate: (character: AnnotatedCharacter | null) => boolean): boolean {
    return this.characters.some(predicate)
  }

  forEach(callback: (character: AnnotatedCharacter | null, index?: number) => void): void {
    this.characters.forEach((annotatedCharacter, index) => {
      callback(annotatedCharacter, index)
    })
  }
}

export { AnnotatedWord }
